import type { PackageType } from '@/features/operation-packages/api';

export const PACKAGE_TYPE_TO_GROUP: Partial<Record<PackageType, string>> = {
  // Apps
  AppUserCreation: 'apps',
  BulkAppUserCreation: 'apps',
  BulkAppUserDeactivation: 'apps',
  MailAddressCreation: 'apps',

  // Licenses
  LicenseAssignment: 'apps',

  // Devices
  DeviceInventory: 'devices',
  DeviceInventoryLabelCreation: 'devices',
  DeviceArrangement: 'devices',
  DeviceLending: 'devices',
  DeviceReturn: 'devices',
  BYODRegistration: 'devices',
  EquipmentInventoryLabelCreation: 'devices',
  EquipmentOrderRequest: 'devices',
  EquipmentDamageAndLossReport: 'devices',
};
